<template>
    <div class="container-fluid">
        <div class="row">
        <div class="sidebar-nav py-2 col-lg-2 col-md-3 col-sm-12">
            <div class="sidebar-text">
                <label class="pl-1 head-title">Filter data</label>
                <form @submit.prevent="filter" v-if="form">
                    <label class="pl-2 sub-title">Werkruimte</label>
                    <div class="form-label-group countries-list">
                        <div v-if="USER">
                            <button :class="[country.checked ? 'active' : '']"
                                    @click="checkCountry(country)"
                                    class="btn btn-lg btn-outline-primary btn-block btn-login text-uppercase font-weight-bold mb-2 btn-country"
                                    v-bind:key="country.id"
                                    v-for="(country) in USER.countries">
                                <i :class="[country.checked ? 'fa-check-square-o' : 'fa-square-o']"
                                   class="fa fa-lg mr-2"></i>{{country.name}}
                            </button>
                        </div>
                    </div>
                    <label class="pl-2 sub-title">Datum</label>
                    <VueCtkDateTimePicker :custom-shortcuts="[
                                                  { key: 'Today', label: 'Today', value: 'day' },
                                                  { key: 'thisWeek', label: 'This week', value: 'isoWeek' },
                                                  { key: 'lastWeek', label: 'Last week', value: '-isoWeek' },
                                                  { key: 'last7Days', label: 'Last 7 days', value: 7 },
                                                  { key: 'last30Days', label: 'Last 30 days', value: 30 },
                                                  { key: 'thisMonth', label: 'This month', value: 'month' },
                                                  { key: 'lastMonth', label: 'Last month', value: '-month' },
                                                  { key: 'thisYear', label: 'This year', value: 'year' },
                                                  { key: 'lastYear', label: 'Last year', value: '-year' }
                                                ]" :no-button="true" :no-label="true"
                                          :only-date="true" :range="true"
                                          format="YYYY-MM-DD" formatted="DD/MM/YYYY" label="Kies een datum"
                                          v-model="form.date"
                                          v-on:input="filter"
                                          v-on:validate="filter"></VueCtkDateTimePicker>
                    <div v-if="currentWorkspace('2019/20')">
                        <label class="pl-2 sub-title mt-2">SALES</label>
                        <multiselect :clear-on-select="false"
                                     :close-on-select="false"
                                     :options="sales"
                                     :preserve-search="true"
                                     :showLabels="false"
                                     @input="filter"
                                     open-direction="top"
                                     placeholder="Choose person"
                                     v-model="form.sales_modular"
                                     value="test">
                            <template slot="clear">
                                <div :style="form.sales_modular.length == 0 ? 'display: none' : 'display:block'"
                                     @mousedown.prevent.stop="clearAll('sales')"
                                     class="multiselect__clear"></div>
                            </template>
                        </multiselect>
                    </div>
                    <button :disabled="loadbutton"
                            class="btn btn-lg btn-secondary btn-block btn-login text-uppercase font-weight-bold mb-2 mt-3 btn-filter"
                            type="submit"><span v-if="!loadbutton">Filter</span>
                        <div v-else><span aria-hidden="true" class="spinner-border spinner-border-sm"
                                          role="status"></span> Laden...
                        </div>
                    </button>
                </form>
            </div>
        </div>
        <div class="pricing py-4   col-lg-10  col-md-9 col-sm-12" v-if="!CHART_MODAL.show">
            <div class="row">
                <!-- Plus Tier -->
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="(currentWorkspace('AM') || currentWorkspace('2019/20')) ">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase text-center">
                                <span v-if="currentWorkspace('AM')">Lead status distribution</span>
                                <span v-if="currentWorkspace('2019/20')">Lead status distribution</span>
                            </h5>
                            <hr>
                            <lead-source-distribution :chartData="CHART_LEAD_SOURCE_DISTRIBUTION"
                                                      @generated="setLegend"
                                                      chart-id='leadSource-chart'
                                                      ref="leadDistribution" v-if="loaded && !loadbutton" />
                            <loader-pie v-else />
                            <div class="legend-con" style="overflow-y: scroll; height:66px;"
                                 v-if="loaded && !loadbutton">
                                <div>
                                    <div @click="changeChart($event, item.datasetindex)" class="chart-legend-container"
                                         v-bind:key="key" v-for="(item, key) in message">
                                        <span :style="'background-color: ' + item.color" class="chart-legend"></span>
                                        <span class="chart-legend-label-text">{{item.label}} ({{item.data}})</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Pro Tier -->
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"  v-if="(currentWorkspace('AM') || currentWorkspace('CLIENTS'))">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase text-center">
                                <span v-if="currentWorkspace('AM')">Conversie van passief</span>
                                <span v-if="currentWorkspace('CLIENTS')">Conversie van afspraak</span>
                            </h5>
                            <hr>
                            <default-pie-chart :chartData="CHART_CONV_FROM_PASSIVE" v-if="loaded && !loadbutton" />
                            <loader-pie v-else />
                        </div>
                    </div>
                </div>
                <!-- Free Tier -->
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"  v-if="(currentWorkspace('AM') || currentWorkspace('CLIENTS'))">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase text-center">
                                <span v-if="currentWorkspace('AM')">Conversie van in contact</span>
                                <span v-if="currentWorkspace('CLIENTS')">Conversie van confirmatie</span>
                            </h5>
                            <hr>
                            <default-pie-chart :chartData="CHART_CONV_FROM_ACTIVE" v-if="loaded && !loadbutton" />
                            <loader-pie v-else />
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="currentWorkspace('AM')">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase text-center">Infobrochure ifv contact</h5>
                            <hr>
                            <default-pie-chart :chartData="CHART_INFOBROCHURE" v-if="loaded && !loadbutton" />
                            <loader-pie v-else />
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="currentWorkspace('CLIENTS')">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase text-center">Voorstellen</h5>
                            <hr>
                            <default-pie-chart :chartData="CHART_PROPOSALS" v-if="loaded && !loadbutton" />
                            <loader-pie v-else />
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="currentWorkspace('CLIENTS')">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase text-center">Klant fase</h5>
                            <hr>
                            <default-pie-chart :chartData="CHART_PROJECT_DISTRIBUTION" v-if="loaded && !loadbutton" />
                            <loader-pie v-else />
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="currentWorkspace('2019/20')">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase text-center">Graag seats in seizoen</h5>
                            <hr>
                            <default-pie-chart :chartData="CHART_SEATS_DISTRIBUTION" v-if="loaded && !loadbutton" />
                            <loader-pie v-else />
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="currentWorkspace('2019/20')">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase text-center">Aantal leads</h5>
                            <hr>
                            <default-pie-chart :chartData="CHART_SALES_DISTRIBUTION" v-if="loaded && !loadbutton" />
                            <loader-pie v-else />
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="(currentWorkspace('CLIENTS') || currentWorkspace('2019/20'))">
                    <div class="card mb-4">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase text-center">Packet distribution</h5>
                            <hr>
                            <packet-distribution :chartData="CHART_PACKET_DISTRIBUTION"
                                                 @generated="setLegendPacket"
                                                 chart-id='leadSource-chart'
                                                 ref="packetDistribution" v-if="loaded && !loadbutton" />
                            <loader-pie v-else />
                            <div class="legend-con" style="overflow-y: scroll; height:66px;"
                                 v-if="loaded && !loadbutton">
                                <div>
                                    <div @click="changeChartPacket($event, item.datasetindex)" class="chart-legend-container"
                                         v-bind:key="key" v-for="(item, key) in messagePacket">
                                        <span :style="'background-color: ' + item.color" class="chart-legend"></span>
                                        <span class="chart-legend-label-text">{{item.label}} ({{item.data}})</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div :class="'col-12 col-sm-12' + ((currentWorkspace('2019/20')) ? 'col-md-6 col-lg-6 col-xl-6' : 'col-md-9 col-lg-9 col-xl-9')" v-if="currentWorkspace('AM') || currentWorkspace('2019/20')">
                    <div class="card mb-5 mb-lg-0">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase
                            text-center">Sales funnel - gem. tijd (in dagen)</h5>
                            <hr>
                            <sales-funnel :chartData="CHART_SALES_FUNNEL" v-if="loaded && !loadbutton" />
                            <loader-bar v-else />
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-9" v-if="currentWorkspace('CLIENTS')">
                    <div class="card mb-5 mb-lg-0">
                        <div class="card-body mb-4">
                            <h5 class="card-title text-muted text-uppercase
                            text-center">PROJECT FUNNEL</h5>
                            <hr>
                            <line-chart :chartData="CHART_PROJECT_FUNNEL" v-if="loaded && !loadbutton" />
                            <loader-bar v-else />
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3" v-if="currentWorkspace('AM')">
                    <div class="card mb-5 mb-lg-0">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase
                            text-center">Total uitgaand</h5>
                            <hr>
                            <total-calls :chartData="CHART_TOTAL_CALLS" v-if="loaded && !loadbutton" id="totalCallsChart"/>
                            <loader-pie-total v-else />
                        </div>
                    </div>
                </div>

                <div :class="'col-12 col-sm-12 col-md-6 col-lg-6' + (currentWorkspace('2019/20') ? 'col-xl-6' : 'col-xl-3')" v-if="currentWorkspace('2019/20')">
                    <div class="card mb-5 mb-lg-0">
                        <div class="card-body">
                            <h5 class="card-title text-muted text-uppercase
                            text-center">Potential Sales pipeline</h5>
                            <hr>
                            <total-seats :chartData="CHART_TOTAL_SEATS" v-if="loaded && !loadbutton" id="totalCallsChartSeats"/>
                            <loader-pie-total v-else />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <transition mode="out-in" name="slide">
            <modal v-if="CHART_MODAL.show" :reload="loadbutton"></modal>
        </transition>
    </div>
</template>
<script>
    import lineChart from '@/components/charts/line-chart.vue'
    import defaultPieChart from '@/components/charts/default-pie-chart.vue'
    import watchDistribution from '@/components/charts/watch-distribution.vue'
    import vipDistribution from '@/components/charts/vip-distribution.vue'
    import packetDistribution from '@/components/charts/packet-distribution.vue'
    import leadSourceDistribution from '@/components/charts/lead-source-distribution.vue'
    import salesFunnel from '@/components/charts/sales-funnel.vue'
    import totalCalls from '@/components/charts/total-calls.vue'
    import totalSeats from '@/components/charts/total-seats.vue'
    import loaderBar from '@/components/charts/loaders/loader-bar.vue'
    import loaderPie from '@/components/charts/loaders/loader-pie.vue'
    import loaderPieTotal from '@/components/charts/loaders/loader-pie-total.vue'
    import modal from '@/components/lists/modal.vue'
    import Multiselect from 'vue-multiselect'
    import _ from 'underscore'

    import {mapGetters} from 'vuex'

    export default {
        name: 'dashboard',
        data: () => ({
            message: [],
            messagePacket: [],
            sales: [],
            sources: [],
            loaded: false,
            loadbutton: false,
            data: null,
            form: null,
            value: null
        }),
        computed: {
            ...mapGetters([
                'CHART_CONV_FROM_ACTIVE',
                'CHART_CONV_FROM_PASSIVE',
                'CHART_LEAD_SOURCE_DISTRIBUTION',
                'CHART_SALES_FUNNEL',
                'CHART_STATUS_DISTRIBUTION',
                'CHART_PACKET_DISTRIBUTION',
                'CHART_PROJECT_DISTRIBUTION',
                'CHART_PROPOSALS',
                'CHART_TOTAL_CALLS',
                'CHART_MODAL',
                'USER',
                'CHART_FORM',
                'CHART_INFOBROCHURE',
                'CHART_SALES_DISTRIBUTION',
                'CHART_SEATS_DISTRIBUTION',
                'CHART_TOTAL_SEATS',
                'CHART_PROJECT_FUNNEL'
            ])
        },
        components: {
            leadSourceDistribution,
            salesFunnel,
            totalCalls,
            loaderBar,
            loaderPie,
            loaderPieTotal,
            modal,
            Multiselect,
            packetDistribution,
            vipDistribution,
            watchDistribution,
            defaultPieChart,
            lineChart,
            totalSeats
        },
        async mounted() {
            this.loaded = false
            this.loadbutton = true
            this.form = this.CHART_FORM
            await this.$store.dispatch('CALL_CHART_DATA', this.form)
            this.sales = this.USER.sales
            this.loaded = true
            this.loadbutton = false
        },
        methods: {
            async filter() {
                this.loadbutton = true
                await this.$store.dispatch('CALL_CHART_DATA', this.form)
                this.loadbutton = false
            },
            //Speciale legende zetten voor lead source distribution chart
            setLegend(html) {
                this.message = html
            },
            setLegendPacket(html) {
                this.messagePacket = html
            },
            //Klik actie bij de knoppen, voor toe te voegen aan array voor API call
            checkCountry(country) {
                this.form.countries = []
                this.$store.dispatch('uncheckAllCountries')

                let prevCountry = this.$_.clone(this.form.countries)

                //Array in orde brengen om te versturen naar API
                if (country.checked) {
                    country.checked = false
                    var index = this.form.countries.indexOf(country.value);
                    if (index > -1) {
                        this.form.countries.splice(index, 1);
                    }
                } else {
                    country.checked = true
                    this.form.countries = [country.value]
                }
            },
            //Leaddistribution custom chart legend click, slice show/hide
            changeChart(e, datasetIndex) {

                if (e.target.classList.contains('line-trough')) {
                    e.target.classList.remove('line-trough')
                } else {
                    e.target.classList.add('line-trough')
                }

                this.$refs.leadDistribution.changeSlice(datasetIndex)
            },
            //Status custom chart legend click, slice show/hide
            changeChartPacket(e, datasetIndex) {

                if (e.target.classList.contains('line-trough')) {
                    e.target.classList.remove('line-trough')
                } else {
                    e.target.classList.add('line-trough')
                }

                this.$refs.packetDistribution.changeSlice(datasetIndex)
            },
            //Clear sources
            clearAll(clearWhat) {
                if (clearWhat == 'sales') {
                    this.form.sales_modular = ""
                } else if (clearWhat == 'sources') {
                    this.form.sources = []
                }
                this.filter()
            },
            //Sales of alfabet zetten
            orderSales() {
                this.sales = this.$_.sortBy(this.sales)
            },
            //Kijken wat de huidige workspace is -> true, dan tonen
            currentWorkspace(workspace){
                if (this.form) {
                    if (this.form.countries[0] === workspace) {
                        return true;
                    }else{
                        return false;
                    }
                }
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

    .slide-enter-active {
        animation: slide-in 200ms ease-out forwards;
    }

    .slide-leave-active {
        animation: slide-out 200ms ease-out forwards;
    }

    @keyframes slide-in {
        from {
            transform: translateY(-30px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;

        }
    }

    @keyframes slide-out {
        from {
            transform: translateY(0);
            opacity: 1;
        }
        to {
            transform: translateY(-30px);
            opacity: 0;

        }
    }


    .head-title {
        font-size: 25px;
        color: #6c757d;
    }

    .sub-title {
        font-size: 15px;
        color: #6c757d;
        text-transform: uppercase !important;
    }

    .field-input, #country {
        border-radius: 0.9rem !important;
        height: 45px !important;
    }

    .btn-country {
        text-align: left;
        padding: 0.60rem 1rem !important;
        color: #522f91;
        border-color: #522f91;
    }

    .active, .btn-country:hover{
        background-color: #522f91!important;
        border-color: #522f91;
    }

    .btn-filter{
        background-color: #d39606;
        border-color: #d39606;
    }

    .btn-filter:hover{
        background-color: #b37d00;
        border-color: #b37d00;
    }

    .card{
        height: 95%;
    }
    /*Onderste row charts fitten op 1 pagina*/
    #horizontalbar-chart, #totalCallsChart {
        height: 275px !important;
    }
    @media (max-width: 400px) {
        #totalCallsChartSeats {
            height: 360px !important;
        }
    }

    #leadSource-chart {
        height: 80% !important;
        width: 80% !important;
        margin: auto;
    }

    /*Sidebar nav*/
    .sidebar-nav {
        /*position: absolute;*/
        /*width: 300px;*/
        /*list-style: none;*/
        /*margin: 0;*/
        /*padding: 0;*/
    }

    .sidebar-text {
        padding: 5px
    }

    /* Change this breakpoint if you change the breakpoint of the navbar */

    @media (min-width: 992px) {
        .animate {
            animation-duration: 0.3s;
            -webkit-animation-duration: 0.3s;
            animation-fill-mode: both;
            -webkit-animation-fill-mode: both;
        }
    }

    @keyframes slideIn {
        0% {
            transform: translateY(1rem);
            opacity: 0;
        }
        100% {
            transform: translateY(0rem);
            opacity: 1;
        }
        0% {
            transform: translateY(1rem);
            opacity: 0;
        }
    }

    @-webkit-keyframes slideIn {
        0% {
            -webkit-transform: transform;
            -webkit-opacity: 0;
        }
        100% {
            -webkit-transform: translateY(0);
            -webkit-opacity: 1;
        }
        0% {
            -webkit-transform: translateY(1rem);
            -webkit-opacity: 0;
        }
    }

    .slideIn {
        -webkit-animation-name: slideIn;
        animation-name: slideIn;
    }

    /* Other styles for the page not related to the animated dropdown */

    /*Pricing*/
    /*.pricing {*/
        /*margin-left: 300px;*/
    /*}*/

    .pricing .card {
        border: none;
        border-radius: 1rem;
        transition: all 0.2s;
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
    }

    /*.card-body{*/
    /*height: 300px;*/
    /*}*/

    .pricing hr {
        margin: 1.5rem 0;
    }

    .pricing .card-title {
        margin: 0.5rem 0;
        font-size: 0.9rem;
        letter-spacing: .1rem;
        font-weight: bold;
    }

    .pricing .card-price {
        font-size: 3rem;
        margin: 0;
    }

    .pricing .card-price .period {
        font-size: 0.8rem;
    }

    .pricing ul li {
        margin-bottom: 1rem;
    }

    .pricing .text-muted {
        opacity: 0.7;
    }

    .pricing .btn {
        font-size: 80%;
        border-radius: 5rem;
        letter-spacing: .1rem;
        font-weight: bold;
        padding: 1rem;
        opacity: 0.7;
        transition: all 0.2s;
    }

    /* Hover Effects on Card */

    @media (min-width: 992px) {
        .pricing .card:hover {
            margin-top: -.25rem;
            margin-bottom: .25rem;
            box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3);
        }

        .pricing .card:hover .btn {
            opacity: 1;
        }
    }

    /*Form*/
    :root {
        --input-padding-x: 1.5rem;
        --input-padding-y: 0.75rem;
    }

    .btn-login {
        font-size: 0.9rem;
        letter-spacing: 0.05rem;
        padding: 0.70rem 1rem;
        border-radius: 0.9rem;
    }

    .form-label-group {
        position: relative;
        margin-bottom: 1rem;
    }

    .form-label-group > input,
    .form-label-group > label,
    .form-label-group > select {
        padding: var(--input-padding-y) var(--input-padding-x);
        height: auto;
        border-radius: 0.9rem;
    }

    .form-label-group > label {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        margin-bottom: 0;
        /* Override default `<label>` margin */
        line-height: 1.5;
        color: #495057;
        cursor: text;
        /* Match the input under the label */
        border: 1px solid transparent;
        border-radius: .25rem;
        transition: all .1s ease-in-out;
    }

    .form-label-group input::-webkit-input-placeholder {
        color: transparent;
    }

    .form-label-group input:-ms-input-placeholder {
        color: transparent;
    }

    .form-label-group input::-ms-input-placeholder {
        color: transparent;
    }

    .form-label-group input::-moz-placeholder {
        color: transparent;
    }

    .form-label-group input::placeholder {
        color: transparent;
    }

    .form-label-group input:not(:placeholder-shown) {
        padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
        padding-bottom: calc(var(--input-padding-y) / 3);
    }

    .form-label-group input:not(:placeholder-shown) ~ label {
        padding-top: calc(var(--input-padding-y) / 3);
        padding-bottom: calc(var(--input-padding-y) / 3);
        font-size: 12px;
        color: #777;
    }

    /* Fallback for Edge
    -------------------------------------------------- */

    @supports (-ms-ime-align: auto) {
        .form-label-group > label {
            display: none;
        }

        .form-label-group input::-ms-input-placeholder {
            color: #777;
        }
    }

    /* Fallback for IE
    -------------------------------------------------- */

    @media all and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
        .form-label-group > label {
            display: none;
        }

        .form-label-group input:-ms-input-placeholder {
            color: #777;
        }
    }

    /*Vue-multiselect style*/
    .multiselect__tags {
        border-radius: 0.9rem !important;
        border: 1px solid #ced4da;
        min-height: 45px !important;
        padding: 10px 40px 0 8px;
    }

    .multiselect--active .multiselect__tags {
        border-radius: 0.2rem 0.2rem 0.9rem 0.9rem !important;
        border: 1px solid #ced4da;
    }

    .multiselect__placeholder {
        padding-top: 0px;
        padding-left: 5px;
    }

    .multiselect__select {
        top: 4px;
    }

    .multiselect__option {
        font-size: 13px;
    }

    .multiselect__clear {
        position: absolute;
        right: 41px;
        height: 40px;
        width: 40px;
        display: block;
        cursor: pointer;
        z-index: 2;
    }

    .multiselect__clear:after, .multiselect__clear:before {
        content: "";
        display: block;
        position: absolute;
        width: 3px;
        height: 13px;
        background: #999;
        top: 15px;
        right: 0px;
    }

    .multiselect__clear:before {
        transform: rotate(45deg);
    }

    .multiselect__clear:after {
        transform: rotate(-45deg);
    }

    .multiselect__placeholder {
        color: #757575 !important;
    }

    .head-title {
        margin-bottom: 0rem !important;
    }

    .countries-list {
        margin-bottom: 0.3rem;
    }
</style>
